import {ReadNewsItemsStore} from "app/news/store/read-items/ReadNewsItemsStore";
import {NewsHeadlineStreamStore} from "./stream/NewsHeadlineStreamStore";
import {NewsStoreFactory} from "./headlines/NewsStoreFactory";
import {NewsSessionIdStore} from "./news-id/NewsSessionIdStore";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.store`;
    return angular.module(moduleName, [])
                  .service(ReadNewsItemsStore.id, ReadNewsItemsStore)
                  .service(NewsStoreFactory.id, NewsStoreFactory)
                  .service(NewsHeadlineStreamStore.id, NewsHeadlineStreamStore)
                  .service(NewsSessionIdStore.id, NewsSessionIdStore)
                  .name;
}
